import React, { useRef, useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import colors from '@settings/styleSettings'

import communicationIcon from '@assets/icons/communicationIcon.svg'

import PrimaryButton from '@components/inputs/button/primaryButton'
import Label from '@components/inputs/label'
import Select from '@components/inputs/select'
import MultipleSelect from '@components/inputs/multipleSelect'
import RequiredFields from '@components/requiredFields'
import Loading from '@components/loading'
import CheckBox from '@components/inputs/checkBox'
import SendMessageModal from '@components/modal/sendMessageModal'

import {
  CloseIcon,
  Column,
  Container,
  Section,
  Subtitle,
  Title,
  Divisor,
  Textarea,
  Icon,
  IconContainer,
  CheckBoxText,
  CheckBoxContainer,
} from './styles'

import { getBeneficiariesToMessage as getBeneficiariesAction } from '@actions/beneficiary'
import { sendNotification as sendNotificationAction } from '@actions/notification'

import 'material-icons/iconfont/outlined.css'

import Modal from '..'

const MessageSenderModal = ({
  filterState,
  isOpen,
  setClose,
  company,
  programme,
  selectedBeneficiaries,
  beneficiaries,
  getBeneficiariesToMessage,
  sendNotification,
}) => {
  const [content, setContent] = useState('')
  const renderCommunicationLabel = () => {
    return (
      <IconContainer>
        <img src={communicationIcon} alt="communication icon" />
        Comunicado
      </IconContainer>
    )
  }
  const renderNoticeLabel = () => {
    return (
      <IconContainer>
        <Icon className="material-icons-outlined">error</Icon>
        Aviso
      </IconContainer>
    )
  }
  const messageTypeEnum = [
    { value: 'Comunicado', label: renderCommunicationLabel() },
    { value: 'Aviso', label: renderNoticeLabel() },
  ]
  const [messageType, setMessageType] = useState({
    value: 'Comunicado',
    label: renderCommunicationLabel(),
  })
  const { companyId, programmeId } = useParams()
  const [isGlobal, setIsGlobal] = useState(false)
  const [isModalopen, setModalIsOpen] = useState(false)
  const [modalTitle, setModalTitle] = useState('')
  const [searchTerm, setSearchTerm] = useState('')
  const [errorDetail, setErrorDetail] = useState('')
  const [subtitle, setSubtitle] = useState(null)
  const textareaRef = useRef(null)
  const [loading, setLoading] = useState(false)
  const [loadingBeneficiaries, setLoadingBeneficiaries] = useState(false)
  const [initialPageSize, setInitialPageSize] = useState(10)
  const [beneficiariesToMessage, setBeneficiariesToMessage] = useState([])
  const [selectedBeneficarySelectedEnum, setSelectedBeneficarySelectedEnum] = useState([])

  const validation = () => {
    if ((isGlobal === false && beneficiariesToMessage.length === 0) || content === '' || messageType === '') {
      return false
    }
    return true
  }
  useEffect(() => {
    setLoadingBeneficiaries(true)
    getBeneficiariesToMessage(
      {
        ...filterState,
        page: 0,
        searchTerm,
        pageSize: initialPageSize,
        companyId,
        programmeId
      },
      () => setLoadingBeneficiaries(false)
    )
  }, [initialPageSize, searchTerm])

  useEffect(() => {
    if (beneficiaries) {
      const updatedSelection = beneficiaries.map((beneficiary) => ({
        value: {
          id: beneficiary.id,
          isSelected:
            selectedBeneficiaries.some(
              (selected) => selected.id === beneficiary.id
            ) || beneficiariesToMessage.includes(beneficiary.id),
        },
        label: beneficiary.name,
      }))
      setSelectedBeneficarySelectedEnum(updatedSelection)
    } else {
      setSelectedBeneficarySelectedEnum([])
      setBeneficiariesToMessage([])
    }
  }, [beneficiaries, selectedBeneficiaries])

  useEffect(() => {
    const initialSelectedBeneficiaryIds = selectedBeneficiaries.map(
      (selected) => selected.id
    )
    setBeneficiariesToMessage(initialSelectedBeneficiaryIds)
  }, [selectedBeneficiaries])

  const handleSelectBeneficiary = (selectedId) => {
    const updatedSelection = selectedBeneficarySelectedEnum.map(
      (beneficiary) => {
        if (beneficiary.value.id === selectedId) {
          return {
            ...beneficiary,
            value: {
              ...beneficiary.value,
              isSelected: !beneficiary.value.isSelected,
            },
          }
        }
        return beneficiary
      }
    )
    setSelectedBeneficarySelectedEnum(updatedSelection)

    const selectedBeneficiaryIds = updatedSelection
      .filter((beneficiary) => beneficiary.value.isSelected)
      .map((beneficiary) => beneficiary.value.id)

    setBeneficiariesToMessage(selectedBeneficiaryIds)
  }

  useEffect(() => {
    adjustTextareaHeight()
  }, [content])

  const adjustTextareaHeight = () => {
    const textarea = textareaRef.current
    if (textarea) {
      textarea.style.height = 'auto'
      textarea.style.height = `${textarea.scrollHeight}px`
    }
  }

  const onSaveAndContinue = () => {
    setLoading(true)
    let sendType = 0
    if (programmeId) {
      sendType = 1
    } else if (companyId) {
      sendType = 2
    }
    const data = {
      beneficiaryIds: !isGlobal ? beneficiariesToMessage : [],
      message: content,
      typeMessage: messageType.value === 'Aviso' ? 0 : 1,
      warRead: false,
      sendType,
      global: isGlobal,
      companyId,
      programmeId,
    }
    if (validation()) {
      sendNotification(data, (title, error) => {
        setLoading(false)
        setModalTitle(title)
        setModalIsOpen(true)
        setErrorDetail(error?.message || error?.response?.data?.message)
        if (error?.message === 'Network Error' || error?.message?.includes('ERR_INTERNET_DISCONNECTED')) {
          setSubtitle('Não foi possível enviar a mensagem. Por favor, verifique sua conexão com a internet e tente novamente')
        } else if (error) {
          setSubtitle('Algo inesperado aconteceu. Por favor, tente novamente em alguns minutos. Se o problema persistir, contate o administrador do sistema.')
        }
      })
    } else {
      setModalTitle('Erro ao enviar mensagem')
      setModalIsOpen(true)
      setSubtitle('Preencha todos os campos obrigatórios antes de confirmar o envio')
      setLoading(false)
    }
  }

  return (
    <Modal isOpen={isOpen} style={{ width: '20%' }}>
      <Container>
        <Divisor>
          <CloseIcon className="material-icons-outlined" onClick={setClose}>
            close
          </CloseIcon>
          <Subtitle>Avisos e comunicados</Subtitle>
          <Title>Enviar mensagem</Title>
          <Subtitle>
            {(() => {
              if (company && companyId) {
                return company.name
              }
              if (programme && programmeId) {
                return programme.name
              }
              return 'Geral'
            })()}
          </Subtitle>
        </Divisor>
        <Divisor>
          <Section>
            <Column>
              <Label label="Destinatário" required />
              <CheckBoxContainer>
                <CheckBox
                  checked={isGlobal}
                  onChange={() => setIsGlobal(!isGlobal)}
                />
                <CheckBoxText>Selecionar todos os beneficiários</CheckBoxText>
              </CheckBoxContainer>
              <MultipleSelect
                onSearch={setSearchTerm}
                beneficiaries={beneficiariesToMessage.length}
                disabled={isGlobal}
                loading={loadingBeneficiaries}
                searchTerm={searchTerm}
                onMenuScrollToBottom={() => setInitialPageSize(initialPageSize + 10)}
                onChange={handleSelectBeneficiary}
                options={selectedBeneficarySelectedEnum}
              />
            </Column>
          </Section>
          <Section>
            <Column>
              <Label label="Tipo da mensagem" required />
              <Select
                value={messageType}
                onChange={(e) => setMessageType(e)}
                options={messageTypeEnum}
                defaultValue={messageType}
                borderColor={colors.softGray}
                height={50}
              />
            </Column>
          </Section>
          <Section>
            <Column>
              <Label label="Conteúdo" required />
              <Textarea
                ref={textareaRef}
                value={content}
                onChange={(e) => setContent(e.target.value)}
              />
            </Column>
          </Section>
        </Divisor>
        <RequiredFields />
        <Column>
          <PrimaryButton
            style={{ marginTop: '40%' }}
            onClick={onSaveAndContinue}
          >
            {loading ? <Loading /> : 'Confirmar e enviar'}
          </PrimaryButton>
        </Column>
        <SendMessageModal
          isOpen={isModalopen}
          title={modalTitle}
          subtitle={subtitle}
          detail={errorDetail}
          setClose={() => setModalIsOpen(false)}
        />
      </Container>
    </Modal>
  )
}

MessageSenderModal.propTypes = {
  isOpen: PropTypes.bool,
  setClose: PropTypes.func.isRequired,
  filterState: PropTypes.shape({
    noRisk: PropTypes.bool,
    highRisk: PropTypes.bool,
    mediumRisk: PropTypes.bool,
    lowRisk: PropTypes.bool,
    diabetic: PropTypes.bool,
    hypertensive: PropTypes.bool,
    overweight: PropTypes.bool,
    dyslipidemic: PropTypes.bool,
    search: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }),
  company: PropTypes.object,
  selectedBeneficiaries: PropTypes.array,
  beneficiaries: PropTypes.array,
  getBeneficiariesToMessage: PropTypes.func.isRequired,
  programme: PropTypes.object,
  sendNotification: PropTypes.func.isRequired
}

MessageSenderModal.defaultProps = {
  isOpen: false,
  filterState: {
    noRisk: false,
    highRisk: false,
    mediumRisk: false,
    lowRisk: false,
    diabetic: false,
    hypertensive: false,
    overweight: false,
    dyslipidemic: false,
    search: '',
  },
  company: null,
  selectedBeneficiaries: [],
  beneficiaries: [],
  programme: null,
}

const mapStateToProps = ({ beneficiary, company, programme }) => ({
  beneficiaries: beneficiary.beneficiariesToMessage,
  total: beneficiary.total,
  company: company.company,
  programme: programme.programme,
})

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getBeneficiariesToMessage: getBeneficiariesAction,
    sendNotification: sendNotificationAction,
  },
  dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(MessageSenderModal)
